<template>
    <div class="bg-transparent-green">

        <div class="px-3 max-w-3xl m-auto">
            <div v-bind:class="ifLoading" class="loader">
                <TheSpinner />
            </div>
            <div v-if="loading" class="text-lg p-5 leading-relaxed">
                <the-language :de="items[1].content" :en="items[1].content_en" />
                <the-button-link de="Zur Anmeldung" en="Registration" router="anmeldung"/>
            </div>
        </div>
    </div>
</template>


<script>
    import TheSpinner from "../TheSpinner"
    import TheLanguage from "../TheLanguage";
    import TheButtonLink from "../TheButtonLink";

    export default {
        name: 'homepage',
        components: {
            TheSpinner,
            TheLanguage,
            TheButtonLink
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/ausschreibung.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        watch: {
            '$route.params.id': function (id) {
                this.loading = false;
                const baseURI = 'https://api.pgsi2020.de/api/file/ausschreibung.json'
                this.$http.get(baseURI)
                    .then((result) => {
                        this.items = result.data,
                            this.loading = true
                    })
            }
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>
